/*
 * Copyright (C) 2025 to Present Applause App Quality, Inc. All rights reserved.
 */

import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  ChangeDetectorRef,
} from '@angular/core';
import {
  trigger, state, style, transition, animate,
} from '@angular/animations';

@Component({
  selector: 'ut-load-more',
  templateUrl: './load-more.component.html',
  styleUrls: ['./load-more.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('fadeState', [
      state('visible', style({
        opacity: 1,
      })),
      state('hidden', style({
        opacity: 0,
      })),
      transition('visible => hidden', animate('300ms ease-out')),
      transition('hidden => visible', animate('300ms ease-in')),
    ]),
  ],
  standalone: false,
})
export class LoadMoreComponent {
  @Input() isLoading = false;
  @Input() isLastPage = false;
  @Input() label = 'Load More';

  @Output() loadMore = new EventEmitter<void>();

  fadeState: 'visible' | 'hidden' = 'visible';

  constructor(private cdr: ChangeDetectorRef) {}

  onLoadMore(): void {
    // Trigger fade out animation
    this.fadeState = 'hidden';
    this.cdr.markForCheck();

    // Emit load more event
    this.loadMore.emit();

    // Fade back in after content loads (2 seconds like original)
    setTimeout(() => {
      this.fadeState = 'visible';
      this.cdr.markForCheck();
    }, 2000);
  }
}
